import { render, staticRenderFns } from "./StockHeader.vue?vue&type=template&id=4da95a6c&scoped=true"
import script from "./StockHeader.vue?vue&type=script&lang=js"
export * from "./StockHeader.vue?vue&type=script&lang=js"
import style0 from "./StockHeader.vue?vue&type=style&index=0&id=4da95a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da95a6c",
  null
  
)

export default component.exports